export default "__VITE_ASSET__DDpt4Zwy__"